//import loadable from '@loadable/component';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import Header from '@components/Header';
import Footer from '@components/Footer';
import Modals from '@components/@modals';
import Landing from '../Manage/Landing';
import Content from './Dashboard';

//const HCMChat = loadable(() => import('./Chat'), { ssr: false });
//@TODO: Delete this HCMChat stuff once fully ok with this.
const Dashboard = () => {
    const auth = useSelector((state) => state.app.token);

    return (
        <div className="dashboard">
            {auth ? (
                    <>
                        <Header />
                        <Content />
                        <Footer />
                    </>
            ) : (
                <Landing />
            )}              
                <Modals />
                {/* <HCMChat /> */}
                <ToastContainer autoClose={3000} />
        </div>
    )
};

export default Dashboard;
